import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AvatarModule } from 'src/app/components/avatar/avatar.module';
import { ResponseInputModule } from 'src/app/components/custom-fields/response-input/response-input.module';

import { DatetimePickerModule } from '../components/datetime-picker/datetime-picker.module';

import { ProfilePageRoutingModule } from './profile-routing.module';
import { ProfilePage } from './profile.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxTippyModule,
    NgxDatatableModule,
    ProfilePageRoutingModule,
    ResponseInputModule,
    DatetimePickerModule,
    AvatarModule,
  ],
  declarations: [ProfilePage],
})
export class ProfilePageModule {}
